// src/CompanyRegister/Step1.js
import React, { useState } from "react";
import { toast } from "sonner";
import RegisterModal from "./RegisterModal"; // Nuevo import
import { Card, CardContent } from "../components/ui/card";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import { fetchWithAuth } from "../Context/UserContext";
import API_URL from "../config";

const Step1 = ({ onNext, formData }) => {
  const [nombreEmpresa, setNombreEmpresa] = useState(
    formData?.nombreEmpresa || ""
  );
  const [ruc, setRuc] = useState(formData?.ruc || "");
  const [direccion, setDireccion] = useState(formData?.direccion || "");
  const [isModalOpen, setIsModalOpen] = useState(false); // Estado para el modal
  const [selectedService, setSelectedService] = useState(
    formData?.sector || ""
  );
  const [checkingRuc, setCheckingRuc] = useState(false);

  const handleNext = async () => {
    if (!nombreEmpresa || !ruc || !selectedService) {
      toast.warning("Por favor completa todos los campos.");
      return;
    }

    if (direccion.length === 0 || direccion.length > 500) {
      toast.error("La dirección no debe estar vacía ni exceder los 500 caracteres.");
      return;
    }

    if (!/^[0-9]{11}$/.test(ruc)) {
      toast.error("El RUC debe contener exactamente 11 dígitos numéricos.");
      return;
    }

    setCheckingRuc(true);
    try {
      const response = await fetchWithAuth(
        `${API_URL}/bs/get_company_by_ruc?ruc=${ruc}`
      );
      if (response.ok) {
        const existingCompany = await response.json();
        toast.error(
          `El RUC ${ruc} ya está registrado con la empresa "${existingCompany.nombre_empresa}".`
        );
        return;
      }
    } catch (error) {
      console.error("Error al verificar el RUC:", error);
    } finally {
      setCheckingRuc(false);
    }

    onNext({ nombreEmpresa, ruc, sector: selectedService, direccion });
  };

  return (
    <Card>
      <CardContent className="space-y-4 pt-6">
        <h3 className="text-xl font-semibold text-foreground">Paso 1: Identificación</h3>
        <form className="space-y-4" onSubmit={(e) => e.preventDefault()}>
          <div>
            <label className="mb-1.5 block text-sm font-medium text-foreground">Nombre de la Empresa</label>
            <Input
              type="text"
              value={nombreEmpresa}
              onChange={(e) => {
                if (e.target.value.length <= 70) {
                  setNombreEmpresa(e.target.value);
                }
              }}
              placeholder="Ejemplo: Soluciones XYZ"
              maxLength={70} // Asegura que el límite también se aplica en navegadores sin onChange
            />
          </div>

          <div>
            <label className="mb-1.5 block text-sm font-medium text-foreground">RUC vigente de la empresa</label>
            <Input
              type="number"
              value={ruc}
              onChange={(e) => {
                if (e.target.value.length <= 11) {
                  setRuc(e.target.value);
                }
              }}
              placeholder="Ejemplo: 12345678901"
            />
          </div>

          <div>
            <label className="mb-1.5 block text-sm font-medium text-foreground">
              Segmento en el que se encuentra la empresa
            </label>
            <div className="flex flex-col items-start gap-2">
              <Button type="button" onClick={() => setIsModalOpen(true)}>
                Seleccionar segmento
              </Button>
              {selectedService && (
                <p className="text-sm text-muted-foreground">
                  Segmento seleccionado: {selectedService}
                </p>
              )}
            </div>
            {/* Modal */}
            <RegisterModal
              isOpen={isModalOpen}
              onClose={() => setIsModalOpen(false)}
              selectedOption={selectedService}
              setSelectedOption={setSelectedService}
              title="Seleccionar Servicio"
            />
          </div>

          <div>
            <label className="mb-1.5 block text-sm font-medium text-foreground">Dirección legal</label>
            <Input
              type="text"
              value={direccion}
              onChange={(e) => setDireccion(e.target.value)}
              placeholder="Ejemplo: Av. Principal 123"
              maxLength={500}
            />
          </div>

          <div className="flex justify-end">
            <Button type="button" onClick={handleNext} disabled={checkingRuc}>
              {checkingRuc ? "Verificando RUC..." : "Siguiente"}
            </Button>
          </div>
        </form>
      </CardContent>
    </Card>
  );
};

export default Step1;
